export default __webpack_public_path__ + "static/Logo-425480bcd5247e8525618f308d6c7455.png";